import { NativeBridge } from '../../services/NativeBridge';
import { isIOSNativeShell } from '../../utils/nativeApp';

export interface HuddleConversation {
  id: string;
  name: string;
  /** Omitted by existing project-channel callers. */
  kind?: 'channel' | 'direct';
}

export function huddleConversationName(name: string, kind: HuddleConversation['kind'] = 'channel'): string {
  return kind === 'direct' ? name.trim() : `#${name.trim().replace(/^#+\s*/, '')}`;
}

export function supportsBrowserHuddles(): boolean {
  return !isIOSNativeShell() && !NativeBridge.hasNativeComposer();
}
